module.exports = __webpack_public_path__ + "img/dog-generalinfo.3d215cc5.png";